













































































































































































import axios from 'axios';
import EventBus from '@/eventBus';
import { get, set, orderBy, uniq, debounce } from 'lodash';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoSkelleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';

export default {
    name: 'CoAdminEventsList',
    components: {
        CoTable,
        CoTippy,
        CoLink,
        CoDate,
        CoInput,
        CoIcon,
        CoSkelleton,
    },
    data() {
        return {
            // for upcoming/past switcher
            view: 1,
            // for search
            searchText: '',
            onSearch: false,
            loadingSearch: false,
            next: '', // holds next page url for search result paginagtion
            // items
            objects: [],
            pastObjects: [],
            searchResult: [],

            requestLoading: false,
        };
    },
    watch: {
        searchResult(val) {
            if (!val || val.length === 0) return;
        },
    },
    computed: {
        // Admins can still manage existing events, but creation stays blocked while EventsOff is set.
        isEventsEnabled() {
            return !this.$store?.state?.space?.EventsOff;
        },
        visibleObjects() {
            if (this.onSearch) return this.searchResult;

            if (this.view === 1) return this.objects.concat(this.pastObjects);

            if (this.view === 2) return this.objects;

            if (this.view === 3) return this.pastObjects;

            return this.objects;
        },
    },
    mounted() {
        this.requestLoading = true;
        this.getEvents();
    },
    methods: {
        get,
        debounce,
        switchView(number) {
            this.view = number;
        },

        requestFinished() {
            this.requestLoading = false;
            this.switchView(1);
            this.getPastEvents();
        },

        createEvent() {
            if (!this.isEventsEnabled) {
                return;
            }
            this.$router.push('/events/create');
        },

        getEvents(next) {
            this.$store
                .dispatch('getEventsV2', next)
                .then((response) => {
                    if (!get(response, 'objects', null)) {
                        this.requestFinished();
                        return;
                    }

                    // add participant count to the list of objects
                    let objects = get(response, 'objects', []).map((obj) =>
                        set(obj, 'object.ParticipantsCount', get(obj, 'object.Participants', []).length)
                    );
                    // sort descending by startdate
                    objects = orderBy(objects, 'object.StartDate', ['desc']);
                    // append to the list of objects
                    // eslint-disable-next-line prefer-spread
                    this.objects.push.apply(this.objects, objects);

                    if (response.next && response.next != '') {
                        this.getEvents(response.next);
                    } else {
                        this.requestFinished();
                    }
                })
                .catch((error) => {
                    console.log('error loading upcoming events', error);
                    this.requestFinished();
                });
        },

        getPastEvents(next) {
            this.$store
                .dispatch('getPastEvents', next)
                .then((response) => {
                    // add participant count to the list of objects
                    const objects = get(response, 'objects', []).map((obj) =>
                        set(obj, 'object.ParticipantsCount', get(obj, 'object.Participants', []).length)
                    );
                    // append to the list of objects
                    // eslint-disable-next-line prefer-spread
                    this.pastObjects.push.apply(this.pastObjects, objects);
                    if (response.next && response.next != '') {
                        this.getPastEvents(response.next);
                    } else {
                        // if all pages were loaded fetch organizers
                        const upcomingIDs = this.objects.map((obj) => get(obj, 'object.Organizers', [])).flat();
                        const pastIDs = this.pastObjects.map((obj) => get(obj, 'object.Organizers', [])).flat();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // todo show error
                });
        },

        createDuplicate(obj) {
            if (!this.isEventsEnabled) {
                return;
            }
            obj['Title'] = obj['Title'];
            delete obj['Slug'];
            delete obj['Participants'];
            delete obj['ParticipantsCount'];
            delete obj['FullURL']; // remove deprecated field full url which was used to link to external ticketing systems

            this.$store.state.eventDuplicate = obj;
            this.$router.push('/events/create');
        },

        deleteEvent(eventObj) {
            if (!eventObj) return;

            this.deleting = true;
            const data = JSON.stringify(eventObj);
            axios({
                method: 'DELETE',
                url: '/admin/event',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$router.go();
                })
                .catch((error) => {
                    console.log(error);
                    this.deleting = false;
                    if (error && error.response && error.response.status == 404) {
                        EventBus.$emit('ERROR', {
                            Message:
                                'This event was already deleted. Refreshing the page will show correct event list.',
                            Details: '',
                        });
                    } else {
                        EventBus.$emit('ERROR', {
                            Message: 'Failed to delete event due to internal error. Please, contact support',
                            Details: '',
                        });
                    }
                })
                .finally(() => {
                    this.deleting = false;
                });
        },
        nextPage() {
            if (this.next) {
                this.loadingSearch = true;

                axios({
                    method: 'GET',
                    url: this.next,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                    .then((response) => {
                        const tmp = get(response, 'data.objects', []);
                        if (tmp && tmp.length > 0) {
                            this.searchResult = this.searchResult.concat(tmp);
                            this.next = get(response, 'data.next', '');

                            if (this.searchResult.length < 10 && this.next) {
                                this.nextPage();
                            }
                        } else {
                            this.next = '';
                        }
                        this.loadingSearch = false;
                    })
                    .catch((error) => {
                        this.loadingSearch = false;
                    });
            }
        },
        searchEvents: debounce(function (e) {
            this.loadingSearch = true;
            this.onSearch = true;

            // Exit search mode if search text is empty
            if (!this.searchText || (this.searchText && this.searchText.trim() === '')) {
                this.loadingSearch = false;
                this.onSearch = false;
                return;
            }

            if (this.searchText && this.searchText.trim().length < 2) {
                this.loadingSearch = false;
                this.onSearch = false;
                return;
            }
            axios({
                method: 'GET',
                url: `/admin/event/search/${this.searchText}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.searchResult = get(response, 'data.objects', []);
                    this.next = get(response, 'data.next', '');
                    if (this.searchResult?.length < 10 && this.next) {
                        this.nextPage();
                    }
                    this.loadingSearch = false;
                })
                .catch((error) => {
                    this.loadingSearch = false;
                });
        }, 500),
    },
};
